import {useTranslation} from "react-i18next";
import classes from "./AdminText.module.css";
import Textarea, {TextareaProps} from "../../ui/textarea";
import {useCallback, useState} from "react";

type Props = Omit<TextareaProps, "onChange"> & {onChange: (value: string) => void};

export default function AdminText({value, onChange, ...props}: Props) {
  const {t} = useTranslation();

  const setAdminText = useCallback(
    (text) => {
      onChange && onChange(text);
    },
    [onChange],
  );
  const [showAdminTextEditor, setShowAdminTextEditor] = useState<boolean>(false);

  return (
    <div className={classes.adminTextControls}>
      <span className={classes.adminTextToggle} onClick={() => setShowAdminTextEditor(!showAdminTextEditor)}>
        {showAdminTextEditor
          ? t("components.UsersSelect.ConfirmationModal.hideMessage")
          : t("components.UsersSelect.ConfirmationModal.editMessage")}
      </span>
      {showAdminTextEditor && (
        <Textarea
          className={classes.adminTextEditor}
          name="adminText"
          rows={4}
          placeholder={t("components.UsersSelect.ConfirmationModal.messagePlaceholder")}
          value={value}
          onChange={(e) => setAdminText(e.target.value)}
          {...props}
        />
      )}
    </div>
  );
}
